module.exports = __webpack_public_path__ + "img/law-serve-nav-icon09.2d940c14.png";